<template>
  <div>
    <o-table :enable-delete="false" :enable-new="false" :title="$t('sandoz.deliveries')" ref="tableList"
             url="/api/sandoz/contract_line_deliveries?include=contract_line,contract_line.product,contract_line.contract,contract_line.contract_address&per_page=100">
        <template slot="filter">
          <div class="d-flex">
            <div>
              <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                  <o-filter-checkbox :items="types" :title="$t('sandoz.contract_type')" column="contract_type"></o-filter-checkbox>
                  <o-filter-select :items="productList" :title="$t('sandoz.product')" column="product_id" value-field="id" text-field="name_lang"></o-filter-select>
                  <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
                  <o-filter-text :title="$t('sandoz.customer_name')" column="customer_name"></o-filter-text>
                  <o-filter-select :items="stateList" :title="$t('sandoz.status')" column="state"></o-filter-select>
                  <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
                  <o-filter-select :items="productTypes" :title="$t('sandoz.type')" column="product_type" value-field="value" text-field="text"></o-filter-select>
                  <o-filter-select :items="productGroups" :title="$t('sandoz.product_group')" column="product_group" value-field="value" text-field="product_group"></o-filter-select>
                  <o-filter-datepicker :title="$t('sandoz.planned_delivery')" column="planned_delivery"></o-filter-datepicker>
                  <o-filter-datepicker :title="$t('sandoz.informed_date')" column="informed_date"></o-filter-datepicker>
                  <o-filter-datepicker :title="$t('sandoz.delivery_executed')" column="delivery_executed"></o-filter-datepicker>
                  <o-filter-datepicker :title="$t('sandoz.canceled_date')" column="canceled_date"></o-filter-datepicker>
                  <o-filter-select :items="itemTypes" :title="$t('sandoz.item_type')" column="item_type">
                  </o-filter-select>
              </o-filter>
            </div>
            <div class="ml-auto">
              <div class="spinner-border text-primary mr-3" role="status" v-if="antalisExporting">
                <span class="sr-only"></span>
              </div>
              <o-button @click.prevent="$refs.antalismodal.show()" v-else :loading="antalisExporting">Antalis Export</o-button>
              <div class="spinner-border text-primary mr-3" role="status" v-if="exporting">
                <span class="sr-only"></span>
              </div>
              <o-button @click="exportToExcel" v-else :loading="exporting">Export</o-button>
            </div>
          </div>
        </template>
        <template slot="head-end">

        </template>
        <template slot="head">
            <o-table-header column="id">{{$t('core.id')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.contract_no')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.customer_external_id')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.type')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.name')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.customer_name')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.product')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.address')}}</o-table-header>
            <o-table-header column="quantity">{{$t('sandoz.quantity')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.price')}}</o-table-header>
            <o-table-header :sortable="false">{{$t('sandoz.language')}}</o-table-header>
            <o-table-header column="planned_delivery">{{$t('sandoz.planned_delivery')}}</o-table-header>
            <o-table-header column="informed_date">{{$t('sandoz.informed_date')}}</o-table-header>
            <o-table-header column="delivery_executed">{{$t('sandoz.delivery_executed')}}</o-table-header>
            <o-table-header column="canceled_date">{{$t('sandoz.canceled_date')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.contract_line ? props.item.contract_line.data.contract.data.contract_no : "" }}</td>
            <td>{{ props.item.contract_line ? props.item.contract_line.data.contract.data.customer_external_id : "" }}</td>
            <td>{{ props.item.contract_line ? props.item.contract_line.data.contract.data.type : "" }}</td>
            <td>{{ props.item.contract_line && props.item.contract_line.data &&
                props.item.contract_line.data.contract_address &&
                props.item.contract_line.data.contract_address.data ?
                  props.item.contract_line.data.contract_address.data.name : ""
                  }}
            </td>
            <td>{{ props.item.contract_line && props.item.contract_line.data &&
                props.item.contract_line.data.contract_address &&
                props.item.contract_line.data.contract_address.data ?
                props.item.contract_line.data.contract_address.data.company_name : ""
                }}
            </td>
            <td>{{ props.item.contract_line ? props.item.contract_line.data.product.data.name_lang : "" }}</td>
            <td v-html="address(props.item)"></td>
            <td>{{ props.item.quantity }}</td>
            <td>{{ props.item.contract_line ? props.item.contract_line.data.price : "" }}</td>
            <td>{{ props.item.contract_line ? props.item.contract_line.data.contract.data.language : '' }}</td>
            <td>
              {{ props.item.planned_delivery | formatDate }}
              <span v-if="props.item.contract_line && props.item.contract_line.data && props.item.contract_line.data.adhoc_item"
                    class="badge badge-primary" :title="props.item.planned_delivery">
                {{$t('sandoz.adhoc_item_badge')}}
              </span>
              <span v-if="props.item.skip_delivery" class="badge badge-warning" :title="props.item.planned_delivery">
                {{$t('sandoz.no_delivery_needed')}}
              </span>
            </td>
            <td>{{ props.item.informed_date | formatDate }}</td>
            <td>{{ props.item.delivery_executed | formatDate }}</td>
            <td>{{ props.item.canceled_date | formatDate }}</td>
        </template>

    </o-table>

    <b-modal ref="antalismodal" :title="$t('sandoz.antalis_export')" @ok="getAntalisData" :no-close-on-backdrop="true">
      <o-datepicker :typeable="false" :errorField="'from'" :label="$t('sandoz.date_1')" v-model="antalis.from" :class="antalis.fromError ? 'has-error': ''"/>
      <o-datepicker :typeable="false" :errorField="'to'" :label="$t('sandoz.date_2')" v-model="antalis.to" :class="antalis.toError ? 'has-error': ''"/>
      <o-value-select :label="$t('sandoz.available')" :items="availableItems" v-model="antalis.available" :class="antalis.availableError ? 'has-error': ''"></o-value-select>
      <o-value-select :label="$t('sandoz.distributor')" :items="distributors" v-model="antalis.distributor" :class="antalis.distributorError ? 'has-error': ''"></o-value-select>
      <o-value-select :items="antalisItemTypes" :label="$t('sandoz.item_type')" v-model="antalis.itemType"></o-value-select>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
  import { contractYears } from '../../utils/contractYear'
  import moment from 'moment'
  export default {
    data: () => ({
      stateList: [],
      years: [],
      productList: [],
      productGroups: [],
      productTypes: [],
      types: [],
      exporting: false,
      antalisExporting: false,
      antalis : {
        from: null,
        to: null,
        available: null,
        fromError: false,
        toError: false,
        availableError: false,
        distributor:null,
        itemType: 'all'
      },
      availableItems: [],
      distributors: [],
      antalisItemTypes: []
    }),
    mounted() {
      this.products()
      this.groups()
    },
    created() {
      this.years = contractYears()

      this.stateList = [
        {value: 'planned_delivery', text: this.$i18n.t('sandoz.planned_delivery')},
        {value: 'delivery_executed', text: this.$i18n.t('sandoz.delivery_executed')},
      ]
      this.productTypes = [
        {value: 'service', text: this.$i18n.t('sandoz.service')},
        {value: 'marketing_activity', text: this.$i18n.t('sandoz.marketing_activity')}
      ]
      this.types = [
        {value: 'APO', text: this.$i18n.t('sandoz.apo')},
        {value: 'APO_ONE', text: this.$i18n.t('sandoz.apo_one')},
        {value: 'SD', text: this.$i18n.t('sandoz.sd')},
        {value: 'CNS', text: this.$i18n.t('sandoz.cns')},
        {value: 'HEIM', text: this.$i18n.t('sandoz.heim')},
        {value: 'IMMUNO', text: this.$i18n.t('sandoz.immuno')},
        {value: 'ONCO', text: this.$i18n.t('sandoz.onco')},
        {value: 'KAM_APO', text: this.$i18n.t('sandoz.kam_apo')},
        {value: 'KAM_SD', text: this.$i18n.t('sandoz.kam_sd')},
        {value: 'KAM_HOSP', text: this.$i18n.t('sandoz.kam_hosp')},
        {value: 'KAM_WHS', text: this.$i18n.t('sandoz.kam_whs')},
        {value: 'OTC', text: this.$i18n.t('sandoz.otc')},
        {value: 'SD_GADGET', text: this.$i18n.t('sandoz.sd_gadget')},
        {value: 'CNS_GADGET', text: this.$i18n.t('sandoz.cns_gadget')},
        /*{value: 'ONCO_GADGET', text: this.$i18n.t('sandoz.onco_gadget')},*/
        {value: 'IMMUNO_GADGET', text: this.$i18n.t('sandoz.immuno_gadget')},
        {value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget')},
        {value: 'APO_GADGET', text: this.$i18n.t('sandoz.apo_gadget')},
        {value: 'KAM_APO_GADGET', text: this.$i18n.t('sandoz.kam_apo_gadget')},
        {value: 'SD_EDU', text: this.$i18n.t('sandoz.sd_edu')},
        {value: 'CNS_EDU', text: this.$i18n.t('sandoz.cns_edu')},
        {value: 'IMMUNO_EDU', text: this.$i18n.t('sandoz.immuno_edu')},
        {value: 'ONCO_EDU', text: this.$i18n.t('sandoz.onco_edu')},
        {value: 'KAM_SD_EDU', text: this.$i18n.t('sandoz.kam_sd_edu')},
        {value: 'APO_EDU', text: this.$i18n.t('sandoz.apo_edu')},
        {value: 'KAM_APO_EDU', text: this.$i18n.t('sandoz.kam_apo_edu')},
        {value: 'BIOS_APO', text: this.$i18n.t('sandoz.bios_apo')},
        {value: 'HIGHSPEC_GADGET', text: this.$i18n.t('sandoz.highspec_gadget')},
        {value: 'BIOS_KAM_APO', text: this.$i18n.t('sandoz.bios_kam_apo')},
        {value: 'BIOS_KAM_WHS', text: this.$i18n.t('sandoz.bios_kam_whs')},
        {value: 'APO_KUKO', text: this.$i18n.t('sandoz.apo_kuko')},
        {value: 'SD_KUKO', text: this.$i18n.t('sandoz.sd_kuko')},
        {value: 'IMMUNO_KUKO', text: this.$i18n.t('sandoz.immuno_kuko')},
        {value: 'HOSP_KUKO', text: this.$i18n.t('sandoz.hosp_kuko')},
        {value: 'CNS_KUKO', text: this.$i18n.t('sandoz.cns_kuko')},
      ]

      this.availableItems = [
        {value: 'yes', text: this.$i18n.t('sandoz.antalis_yes')},
        {value: 'empty', text: this.$i18n.t('sandoz.antalis_no')},
        {value: 'gadget', text: this.$i18n.t('sandoz.antalis_gadget')},
        {value: 'empty_and_gadget', text: this.$i18n.t('sandoz.antalis_no_gadget')},
        {value: 'all', text: this.$i18n.t('sandoz.antalis_all')}
      ]

      this.distributors = [
        {value: 'Antalis', text: 'Antalis'},
        {value: 'Sandoz Rotkreuz', text: 'Sandoz Rotkreuz'}
      ]

      this.itemTypes = [
        { value: 'adhoc', text: this.$i18n.t('sandoz.adhoc') },
        { value: 'standard', text: this.$i18n.t('sandoz.standard') }
      ]

      this.antalisItemTypes = [
        { value: 'all', text: this.$i18n.t('sandoz.antalis_all')},
        { value: 'adhoc', text: this.$i18n.t('sandoz.adhoc') },
        { value: 'standard', text: this.$i18n.t('sandoz.standard') }
      ]
    },
    methods: {
      exportToExcel () {
        const _self = this

        var prevSort = _self.$refs.tableList.sortBy
        var prevSortDesc = _self.$refs.tableList.sortByDirection

        _self.$refs.tableList.sortBy = 'export'
        _self.exporting = true
        _self.$nextTick(() => {
          _self.$refs.tableList.downloadExcel().then((response) => {
            _self.exporting = false
            _self.$refs.tableList.sortBy = prevSort
            _self.$refs.tableList.sortByDirection = prevSortDesc
          })
        })
      },
      products() {
        axios.get('/api/sandoz/products?sortBy=name&per_page=9999').then((response) => {
          this.productList = response.data.data
        }).catch((error) => {
          console.error(error)
        })
      },
      groups() {
        axios.get('/api/sandoz/product_masters/filter/product_group').then((response) => {
          this.productGroups = response.data
        }).catch((error) => {
          console.error(error)
        })
      },
      address(delivery) {
        let address = ''
        let contractLine = delivery.contract_line

        if(!contractLine ||
          !contractLine.data ||
          !contractLine.data.contract_address ||
          !contractLine.data.contract_address.data
        ) {
          return address
        }

        if(contractLine.data.contract_address.data.salutation) {
          address = address.concat(contractLine.data.contract_address.data.salutation)
        }

        if(contractLine.data.contract_address.data.name) {
          address = address.concat(' ' + contractLine.data.contract_address.data.name)
        }

        if(contractLine.data.contract_address.data.last_name) {
          address = address.concat(' ' + contractLine.data.contract_address.data.last_name)
        }

        if(contractLine.data.contract_address.data.del_address ||
          contractLine.data.contract_address.data.street ||
          contractLine.data.contract_address.data.city ||
          contractLine.data.contract_address.data.zip
        ) {
          address = address.concat('<br>')
        }

        if(contractLine.data.contract_address.data.del_address) {
          address = address.concat(contractLine.data.contract_address.data.del_address)
        }

        if(contractLine.data.contract_address.data.street) {
          address = address.concat(', ' + contractLine.data.contract_address.data.street)
        }

        if(contractLine.data.contract_address.data.city ||
          contractLine.data.contract_address.data.zip
        ) {
          address = address.concat('<br>')
        }

        if(contractLine.data.contract_address.data.city) {
          address = address.concat(contractLine.data.contract_address.data.city)
        }

        if(contractLine.data.contract_address.data.zip) {
          address = address.concat(', ' + contractLine.data.contract_address.data.zip)
        }

        return address
      },
      exportAntalis() {
        this.$refs.antalismodal.show()
      },
      getAntalisData(evt) {
        evt.preventDefault()
        var error = false
        this.antalis.fromError = false
        this.antalis.toError = false
        this.antalis.availableError = false
        if(this.antalis.from === null) {
          error = true
          this.antalis.fromError = true
        }

        if(this.antalis.available === null) {
          error = true
          this.antalis.availableError = true
        }

        if(error) {
          this.$notify({
            title: this.$i18n.t('core.error'),
            type: 'error'
          })

          return false
        }

        if(this.antalis.from !== null && (this.antalis.to === null || (this.antalis.to !== null && moment(this.antalis.to).isSameOrAfter(this.antalis.from, 'day')))){
          var date = this.antalis.from
          if(this.antalis.to !== null) {
           date += ','+this.antalis.to
          }
          axios.get('/api/delivery-excel-report/'+date+'/'+this.antalis.available+'/'+this.antalis.itemType+'/'+this.antalis.distributor+'/true', { responseType: 'arraybuffer' }).then((response) => {
            require('downloadjs')(response.data,
              'Antalis.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )

            this.antalis.from = null
            this.antalis.to = null
            this.antalis.available = null
            this.antalis.distributor = null
            this.antalis.fromError = false
            this.antalis.toError = false
            this.antalis.availableError = false
            this.antalis.itemType = 'all'

            this.$refs.antalismodal.hide()

          }).catch((error) => {
            console.error(error)
          })
        } else {
          this.antalis.fromError = true
          this.antalis.toError = true

          this.$notify({
            title: this.$i18n.t('core.error'),
            text: 'From date should be greater than To date',
            type: 'error'
          })

          return false
        }
      }
    }
  }
</script>
